import React from 'react'
import PropTypes from 'prop-types'
import { format } from 'utils/date'
import { Flex, Text, Spacer } from '@jisr-hr/design-system'
import Avatar from 'components/global/templates/RequestDrawer/ds/Avatar/Avatar'
import { statusTypes } from 'utils/uiHelpers'

import WorkFlowBadge from '../WorkFlowBadge'

const EmployeeProfile = ({ name, avatar, jobTitle, code, date, status, status_i18n }) => (
  <Flex itemsStart>
    <Avatar
      src={avatar}
      name={name}
    />
    <Spacer width={8} />
    <Flex flexCol>
      <Text
        typography="paragraph16"
        weight="bold"
        color="var(--color-natural-black-default-new)"
      >
        {name}
      </Text>
      {(date || code || jobTitle) && (
        <Text
          typography="paragraph14"
          color={
            date ? 'var(--color-natural-gray-dark-new)' : 'var(--color-natural-black-light-new)'
          }
        >
          {date ? (
            format(date, 'MMM d, yyyy, hh:mma')
          ) : (
            <>
              {jobTitle} {jobTitle && code && '-'} {code}
            </>
          )}
        </Text>
      )}
      {status_i18n && (
        <>
          <Spacer height={8} />
          <Flex flexWrap>
            <WorkFlowBadge
              label={status_i18n}
              type={statusTypes[status?.toLowerCase()] || 'gray'}
            />
          </Flex>
        </>
      )}
    </Flex>
  </Flex>
)

EmployeeProfile.propTypes = {
  date: PropTypes.instanceOf(Date),
  code: PropTypes.number,
  name: PropTypes.string,
  jobTitle: PropTypes.string,
  avatar: PropTypes.string,
  status: PropTypes.string,
  status_i18n: PropTypes.string,
}

export default EmployeeProfile
